import { render, staticRenderFns } from "./SkyCard.vue?vue&type=template&id=408fcbb0&scoped=true"
import script from "./SkyCard.vue?vue&type=script&lang=js"
export * from "./SkyCard.vue?vue&type=script&lang=js"
import style0 from "./SkyCard.vue?vue&type=style&index=0&id=408fcbb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408fcbb0",
  null
  
)

export default component.exports